import type { DataSetExtra, IPRChartContext } from "./d";
import {
  getWellFlowingPressureUsingPi,
  getMaxFlowRatePI,
  getWellFlowingPressure
} from "../../calculations/ipr";
import { Flow_Model_Enum } from "gql/api";

export const getStraightDataset = (context: IPRChartContext): DataSetExtra => {
  const {
    wellProperties,
    wellTestFlowRates,
    iterations,
    targetLiquidFlowUnit,
    targetPressureUnit,
    fluidPropertiesAtReservoir,
    desiredLiquidRateSTBD
  } = context;
  const operatingPoint = {
    label: "Operating Point",
    point: { x: 0, y: 0 }
  };
  if (!wellProperties) return { points: [], operatingPoint };
  operatingPoint.point = {
    x: targetLiquidFlowUnit.toThisUnit(desiredLiquidRateSTBD),
    y: targetPressureUnit.toThisUnit(
      getWellFlowingPressure(
        Flow_Model_Enum.StraightLine,
        desiredLiquidRateSTBD,
        wellTestFlowRates.liquidFlowRateSTBD,
        wellProperties.well_test_static_bottom_hole_pressure_psia,
        wellProperties.well_test_producing_bottom_hole_pressure_psia,
        fluidPropertiesAtReservoir.bubblePointPressurePSIA,
        wellTestFlowRates.waterCutRatio
      )
    )
  };
  const step =
    getWellFlowingPressureUsingPi(
      wellTestFlowRates.liquidFlowRateSTBD,
      wellProperties.well_test_static_bottom_hole_pressure_psia,
      wellProperties.well_test_producing_bottom_hole_pressure_psia,
      0,
      null
    ) / iterations;

  return {
    title: "Straight",
    xAxisLabel: `Flow (${
      targetLiquidFlowUnit.shortLabel || targetLiquidFlowUnit.label
    })`,
    yAxisLabel: `Pressure (${
      targetPressureUnit.shortLabel || targetPressureUnit.label
    })`,
    points: Array.from({ length: iterations })
      .map((_, i) => {
        const y = step * i;
        const x = getMaxFlowRatePI(
          wellProperties.well_test_static_bottom_hole_pressure_psia,
          wellProperties.well_test_producing_bottom_hole_pressure_psia,
          y,
          wellTestFlowRates.liquidFlowRateSTBD,
          null
        );

        return {
          x: targetLiquidFlowUnit.toThisUnit(x),
          y: targetPressureUnit.toThisUnit(y)
        };
      })
      .filter(pt => pt.x > 0)
      .filter(pt => pt.y > 0),
    operatingPoint
  };
};
